/**
 * replaces all dots '.' in the string with '__'
 * @param string
 */

export const dotToDoubleUnderDash = (string: string) => {
  // only convert those that do not start with a capital letter
  return string.replace(/\./g, '__')
}
